import { PartyDetailModal } from './party-detail-modal';
import { TransportModel } from '../../transport/model/transport-model';
import { UserModal } from '../../user/modal/user-modal';
import { PartyDetailsBranchModel } from './party-details-branch-model';
import { SegmentModel } from '../../segment/model/segment-model';

export class PartyModal {
  id: number;
  companyName: string;
  gstNumber: string;
  panNumber: string;
  partyWebsite: string;
  billAddress: string;
  billAddress2: string;
  billAddress3: string;
  shippingAddress: string;
  shippingAddress2: string;
  shippingAddress3: string;
  state: string;
  stateCode:string;
  partyType: any;
  partyTypeCategory: any;
  accountHolderName: string;
  accountNumber: number;
  bankName: string;
  ifscCode: string;
  contactDetails: Array<PartyDetailModal>;
  country: string;
  transports: TransportModel[];
  selectedCountry: countryModel;
  salesHead: Array<UserModal>;
  vendorCode: string;
  segment: SegmentModel;
  termsOfPayment: string;
  //CBL #Dk
  branchDetails: Array<PartyDetailsBranchModel>;
  owningCompany: number;
  productTypes: any;

  // Angular Use
  currentSalesHead: UserModal;
  partyTypeString: string;

  status: {name: any};
  password:string;
  userName:string;

  rating:number;
  score: number = 0;
  ehsPolicyBody: boolean = false;
  isoManual: boolean = false;
  qacManual: boolean = false;
  copyOfCertification: boolean = false;

  partyDetails: PartyDetailsModal
}

export class countryModel {
  name: string;
  code: string;
}{}


export class PartyDetailsModal{
    swiftCode: string;
    bankBranch: string;
    currency: string;
    labour: string;
    ibanNo: string;
    insurance: string;
    decConfIntre: string;
    companyName2: string;
    typeOfCompany: string;
    physicalAddress: string;
    countryy: string;
    cityy: string;
    telephoneNo: string;
    faxNo: string;
    title: string;
    firstName: string;
    lastName:string;
    tradeLicence: string;
    catCompany: string;
    bankAcc: string;
    legal:string;
    trn: string;
    foreignSupplier: string;
    scopeOfService: string;
    holCompany: string;
    warranty:string;
    ehs: string;
    ehsIso: string;
    qaqc: string;
    qaIso: string;
    minContractValue: string;
    maxContractValue: string;
    financialInfo: string;
    currentlyEmployedWithUs: string;
    lastTwoProjecBond: string;
    currentlyEmployedName:string;
    currentlyEmployedDesignation: string;
    currentlyEmployedPerFrom: string;
    currentlyEmployedWithTo: string;
    dispute: string;
    disNumInsta: string;
    undertaking: string;
    authSignatory:string;
    authDesignation: string;

    heavyEquipMach: string;
    lightEquipMach:string;

    supplierFor: string;
    addiInfoOrga: string;
    contactDetails:string;
    companyName: string;
    validUpto: string;
    issuedOn: string;
    issuedAt: string;
    issuedAuth: string;
    poBox: string;
    telPhoneNo: string;
    score: number;
    additionalInformation: any;
    ehsFileName: string;
    ehsIsoFileName: string;
    qaqcIsoManualFileName: string;
    qaqcManualFileName: string;
}
